module.exports = {
  screens: {
    phone_only: { max: '767.99px' },
    // => @media (max-width: 767.9px) { ... }

    tablet: '768px',
    // => @media (min-width: 768px) { ... }

    desktop: '992px',
    // => @media (min-width: 992px) { ... }

    large_desktop: '1200px',
    // => @media (min-width: 1200px) { ... }

    extra_large_desktop: '1440px',
    // => @media (min-width: 1440px) { ... }
  },
};
